import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DocumentsMainComponent } from './documents-main/documents-main.component';

const routes: Routes = [
    {
        path: 'documents',
        component: DocumentsMainComponent,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class DocumentRoutingModule {}
